import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GlobeIcon, LockIcon, ShieldIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabelSystem, packageContents, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-carbon-graphite" data-id="element-242" data-mp="1j979355ddc59">
      <div className="max-w-3xl mx-auto" data-id="element-243" data-mp="1nasq92oxscl9">
        <div className="text-center mb-12" data-id="element-244" data-mp="1n9r3i0yk61np">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-white" data-id="element-245" data-mp="1s9n6pxzflp27">
            Your complete <span className="text-gold" data-id="element-246" data-mp="1x8qdpnyz25ct">6-in-1 offer</span> today
          </h2>
          <p className="text-mist text-sm md:text-base" data-id="element-247" data-mp="1x6ndkb43uvud">
            The complete teaching system — ready for your next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3
      }} className="border-2 border-gold rounded-3xl p-1 relative" data-id="element-248" data-mp="2vh1vpiye7re">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-carbon font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-249" data-mp="1hpy9zzx61aqp">
            <SparklesIcon size={14} data-id="element-250" data-mp="17rsatq2quipj" /> Complete System · Full Access
          </div>
          <div className="bg-carbon rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-251" data-mp="17ppc8hnizh97">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-252" data-mp="25er9g6czy0q2">
              Brazilian Jiu Jitsu Coach Ready —{' '}
              <span className="text-gold" data-id="element-253" data-mp="1vh30ocik2sow">Complete 6-in-1 Teaching System</span>
            </h3>
            <p className="text-base text-mist mb-6" data-id="element-254" data-mp="1rfri2qy3n7q7">
              Everything you need to teach Brazilian Jiu Jitsu with confidence.
            </p>

            <div className="mb-8 border border-gold/40 rounded-xl px-4 py-4" data-id="element-255" data-mp="k3r5sr4rxkev">
              <p className="text-white font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-256" data-mp="fzjecm6xlqcy">
                6 Complete Volumes.{' '}
                <span className="text-gold" data-id="element-257" data-mp="hfotvnyy1u6a">One Complete Coaching System.</span>
              </p>
              <p className="text-smoke text-xs md:text-sm mt-1 uppercase tracking-wider" data-id="element-258" data-mp="mg30r2ot6y2q">
                300+ visual coaching pages · Everything organized in one 6-in-1 system
              </p>
            </div>

            <ul className="text-left max-w-xl mx-auto mb-8 divide-y divide-carbon-line border-y border-carbon-line" data-id="element-259" data-mp="ckhv8ukj7fo8">
              {packageContents.map(row => <li key={row.label} className="flex items-start gap-3 py-3 text-sm" data-id="element-260" data-mp="3is2nlewyaov">
                  <CheckIcon size={16} className="text-gold shrink-0 mt-0.5" data-id="element-261" data-mp="3kzjfdwdfypdy" />
                  <span className="text-mist" data-id="element-262" data-mp="3px1slyyhrqrr">{row.label}</span>
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-263" data-mp="3byv2x63p4x36">
              <span className="text-lg text-ash line-through block mb-1" data-id="element-264" data-mp="3bzwq28xzla19">$105.00 USD</span>
              <div className="flex items-baseline justify-center gap-3" data-id="element-265" data-mp="3fylz5pbzs5f3">
                <span className="text-2xl md:text-3xl text-white font-semibold" data-id="element-266" data-mp="2xc4t1gbwpw5z">TODAY:</span>
                <span className="text-5xl md:text-6xl font-extrabold text-gold" data-id="element-267" data-mp="2sd1wkk9zsy9m">$27.00</span>
                <span className="text-xl text-gold font-bold" data-id="element-268" data-mp="36c1i3j27kx1k">USD</span>
              </div>
            </div>

            <p className="text-gold font-bold uppercase tracking-widest text-xs md:text-sm mb-4" data-id="element-269" data-mp="31bn83vh1rd0w">
              Open the page. Teach the class.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-3" data-id="element-270" data-mp="3baw0ijw9kjl5">
              {ctaLabelSystem}
            </Button>
            <p className="text-xs text-mist mb-5" data-id="element-271" data-mp="3l1h5qq6g0md1">One-time payment · No subscriptions</p>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-smoke mb-4" data-id="element-272" data-mp="2vkrxyxyjaru">
              <span className="flex items-center gap-1.5" data-id="element-273" data-mp="3u36z41jvxvdg">
                <LockIcon size={12} className="text-cta" data-id="element-274" data-mp="hyvxme7tngp9" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-275" data-mp="lz5yxdko5ixs">
                <ZapIcon size={12} className="text-cta" data-id="element-276" data-mp="lxl9u3h4is7b" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-277" data-mp="qsha1qwiklvi">
                <ShieldIcon size={12} className="text-cta" data-id="element-278" data-mp="vofux4imvlr6" /> 7-day guarantee
              </span>
            </div>

            <div className="border border-carbon-line rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-279" data-mp="3v6730iqwj2ax">
              <GlobeIcon className="text-gold shrink-0 mt-0.5" size={14} data-id="element-280" data-mp="32whcgak6a91" />
              <p className="text-[11px] text-smoke leading-snug" data-id="element-281" data-mp="7ybrax5g3m06">
                Pay in your local currency. The amount adjusts automatically
                based on the country you purchase from.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}